const LAST_UPDATED_DATE = 'December 14, 2025';

export const ScheduleB = () => {
  return (
    <div className="text-left bg-white py-24 sm:py-32 flex-grow">
      <div className="mx-auto max-w-3xl px-6 lg:px-8">
        <h2 className="text-base/7 font-semibold text-primary-50">Legal</h2>
        <p className="mt-2 text-4xl font-semibold tracking-tight text-grey-100 sm:text-5xl">
          Schedule B: Module Addenda
        </p>
        <div className="mt-10 space-y-8 text-base/7 text-grey-300">
          <p>Last updated: {LAST_UPDATED_DATE}</p>

          {/* B1 */}
          <div>
            <h3 className="text-xl font-semibold text-grey-100">
              B1. HealthcareLX Addendum (Marketplace)
            </h3>
            <ul className="list-disc pl-5 mt-2 text-grey-300 space-y-1">
              <li>
                <strong>Marketplace Role:</strong> Company provides software tools; is not the
                employer/agent unless stated in an Order Form.
              </li>
              <li>
                <strong>Negotiation Tools:</strong> Any offers, counters, and confirmations may be
                recorded and time-stamped.
              </li>
              <li>
                <strong>Messaging:</strong> Users should use in-platform messaging; off-platform
                solicitation to evade fees is prohibited.
              </li>
            </ul>
          </div>

          {/* B2 */}
          <div>
            <h3 className="text-xl font-semibold text-grey-100">
              B2. MedCredVault Addendum (Credentialing)
            </h3>
            <ul className="list-disc pl-5 mt-2 text-grey-300 space-y-1">
              <li>
                <strong>Credential Source of Truth:</strong> Providers are responsible for accuracy
                and updates; facilities remain responsible for independent verification.
              </li>
              <li>
                <strong>Authorizations:</strong> Provider may grant facilities/admins access to
                credential packets; access may be revoked as allowed by law and contract.
              </li>
              <li>
                <strong>Sensitive Data Handling:</strong> Credential documents may include sensitive
                data; users must not upload PHI unless permitted and covered by BAA where required.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
